import _ from 'lodash'

export const organize = (num, data) => {
    const organizedData = []
    const flattenedData = _.flattenDepth(data, 1).filter(
        item => Array.isArray(item) ? item.length > 0 : true
    )

    while (flattenedData.length != 0) {
        const organizedDataItem = []

        for (let i = 0; i < num; i++) {
            if (flattenedData.length) {
                organizedDataItem.push(
                    flattenedData.shift()
                )
            } else {
                organizedDataItem.push([])
            }
        }

        organizedData.push(organizedDataItem)
    }

    return organizedData
}

export const organizeDates = (num, datesData) => {
    const organizedData = []
    const flattenedData = _.flattenDeep(datesData, 1)

    while (flattenedData.length != 0) {
        const organizedDataItem = []

        for (let i = 0; i < num; i++) {
            if (flattenedData.length) {
                organizedDataItem.push(
                    flattenedData.shift()
                )
            } else {
                organizedDataItem.push(null)
            }
        }

        organizedData.push(organizedDataItem)
    }

    return organizedData
}
export default { organize, organizeDates }
